import {Component, OnInit} from '@angular/core';
import {
  ApiService,
  UserDetails,
  UserCreateOrUpdate,
  TenantListItem,
  UserClaim
} from "../../../services/api.service";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import {AuthService} from "../../../auth/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {JsonPipe, Location, NgClass, NgForOf, NgIf} from "@angular/common";
import {concat, forkJoin} from "rxjs";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {ErrorPanelComponent} from "../../../core/error-panel/error-panel.component";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatOptionModule} from "@angular/material/core";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatSelectModule} from "@angular/material/select";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";

@Component({
  selector: 'app-user-manage',
  standalone: true,
  imports: [
    ActionsContainerComponent,
    BackButtonComponent,
    ErrorPanelComponent,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatProgressBarModule,
    MatSelectModule,
    NgClass,
    NgForOf,
    NgIf,
    QuickPreviewPanelComponent,
    ReactiveFormsModule,
    JsonPipe
  ],
  templateUrl: './user-manage.component.html'
})
export class UserManageComponent implements OnInit {

  form?: FormGroup
  tenants: TenantListItem[] = []
  claimTypes: string[] = []
  userId?: string
  existing?: UserDetails
  loading = false
  error?: any

  get isNew(): boolean {
    return !this.userId
  }

  get claimsArrayControl(): FormArray {
    return this.form!.get('claims') as FormArray
  }

  get messagesArrayControls(): FormGroup[] {
    return this.claimsArrayControl.controls as FormGroup[]
  }

  get formAsUserCreateUpdateRequest(): UserCreateOrUpdate {
    const result = (this.form!.value as UserCreateOrUpdate)!
    if (this.existing) {
      result.id = this.existing.id
      result.system = this.existing.system
    }
    return result
  }

  constructor(
    readonly api: ApiService,
    readonly authService: AuthService,
    readonly activatedRoute: ActivatedRoute,
    readonly fb: FormBuilder,
    readonly router: Router,
    readonly location: Location
  ) {

  }

  ngOnInit(): void {
    forkJoin([
      this.api.getUserClaims(),
      this.api.getTenants()
    ])
    .subscribe({
      next: ([claims, tenants]) => {
        this.claimTypes = claims as string[]
        this.tenants = tenants as TenantListItem[]
        this.userId = this.activatedRoute.snapshot.params['userId']
        this.invalidateForm()
      }
    })
  }

  ngOnDestroy() {
  }

  castToFormControl(c: AbstractControl) {
    return c as FormControl
  }

  deleteClaimsControlAtIndex(index: number) {
    this.claimsArrayControl.removeAt(index, {
      emitEvent: true
    })
  }

  invalidateForm(): void {
    this.form = this.fb.group({
      isPendingNew: [this.userId == undefined],
      id: this.fb.control({
        value: this.userId,
        disabled: this.userId != undefined
      }, [Validators.required, Validators.email]),
      system: this.fb.control({
        value: this.existing?.system || false,
        disabled: this.userId != undefined
      }, [Validators.required]),
      description: [''],
      tenants: [],
      claims: this.fb.array([])
    })

    if (this.userId) {
      this.loading = true
      this.error = undefined
      this.api.getUser(this.userId).subscribe({
        next: (user) => {
          console.warn('the user', user.tenants)
          user.claims.forEach(() => this.addClaimFormControl())

          this.form!.patchValue(user, {
            emitEvent: true
          })

          this.form!.controls['tenants'] = new FormControl(user.tenants)
          this.existing = user
          this.loading = false
        },
        error: (e) => {
          this.error = e
          this.loading = false
        }
      })
    }
  }

  save(): void {
    if (this.form?.valid) {
      const data = this.formAsUserCreateUpdateRequest
      const createOrUpdate = this.isNew
        ? this.api.createUser(data)
        : this.api.updateUser(data)
      // noinspection DuplicatedCode
      this.error = undefined
      this.loading = true
      createOrUpdate.subscribe({
        next: (_) => {
          this.loading = false
          this.location.back()
        },
        error: (e) => {
          this.loading = false
          this.error = e
        },
      })
    }
  }

  addClaimFormControl() {
    this.claimsArrayControl.push(this.fb.group({
      type: ['', Validators.required],
      value: [null, Validators.required]
    }), {
      emitEvent: true
    })
  }
}
